module.exports = __webpack_public_path__ + "img/tick.36e32df1.png";